// src/functions/gpsLogger.js
// ----------------------------------------------------------
// GPS Logger (leve) — compatível com useGPSHybrid v3.18 +
// Usa o mesmo formato de data: YYYYMMDD
// Ativa se o user tiver gpsDebug=true OU localStorage.gpsDebug="1"
// ----------------------------------------------------------

import { db } from "../firebaseConfig";
import { ref, set } from "firebase/database";
import { useAuthStore } from "../stores/useAuthStore";

export function logGPSFixRemote(fix) {
  try {
    if (!fix || typeof fix.lat !== "number" || typeof fix.lon !== "number") {
      return;
    }

    const user = useAuthStore.getState().user;
    if (!user?.uid) return;

    const uid = user.uid;

    // Ativo se: user.gpsDebug === true OU localStorage.gpsDebug = "1"
    const userFlag =
      user?.gpsDebug === true ||
      user?.debugGPS === true ||
      localStorage.getItem("gpsDebug") === "1";

    if (!userFlag) return;

    // Mesmo formato do useGPSHybrid → YYYYMMDD
    const now = new Date(fix.ts || Date.now());
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const dayKey = `${yyyy}${mm}${dd}`;

    const ts = now.getTime(); // usado como nome do nó

    const payload = {
      lat: fix.lat,
      lon: fix.lon,
      ele: fix.ele ?? null,
      acc: fix.acc ?? null,
      spd: fix.spd ?? null,
      src: fix.src ?? "hybrid",
      ts,
    };

    const path = `/logs/gps/${uid}/${dayKey}/${ts}`;

    return set(ref(db, path), payload)
      .then(() => {
        try {
          // Telemetria que indica que um BlackBox foi escrito (só em modo debug)
          try { require('../stores/useLogsStore.jsx').logEvent?.('gps', 'BlackBox write', { uid, dayKey, ts, lat: payload.lat, lon: payload.lon, src: payload.src }); } catch {}
        } catch {}
      })
      .catch((err) => {
        try {
          try { require('../stores/useLogsStore.jsx').logEvent?.('gps', 'BlackBox write_error', { uid, dayKey, ts, error: String(err) }); } catch {}
        } catch {}
        throw err;
      });
  } catch (e) {
    console.warn("⚠️ logGPSFixRemote falhou:", e);
  }
}